module.exports = "images/enfants_3.2d577729.png";